import React from "react"
import styled, { useTheme } from '~/ui/styled'
import { observer } from "mobx-react-lite"
import { Flex, IconFont} from "~components/El"

const Container = styled(Flex)`
  padding: 10px 15px;
  background-color: #ffffff;
  margin: 5px 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  height: auto;
`

const ContainerBox = styled(Flex)`
  flex-direction: row;
  width: auto;
  height: auto;
  align-items: center;
`
const CurView = styled(Flex)`
  flex-direction: row;
  height: auto;
  margin: 0 8px;
`

const CurText = styled.Text<{ color?: string; size?: number }>`
  font-size: ${({ size }) => (size ? `${size}px` : "14px")};
  color: ${({ color }) => color};
`

const PersonalCardItem: React.FC<any> = ({ isArrow = true, ...rest }) => {
  const theme = useTheme()
  return (
    <Container onClick={rest.onClick}>
      <ContainerBox>
        <CurText color={theme.colors.text}>{rest.title}</CurText>
      </ContainerBox>
      <ContainerBox>
        {rest.type === "sex" || rest.type === "email" ? (
          <CurText color={rest.value ? theme.colors.secondary : theme.colors.primaryText}>
            {rest.value ? rest.value : rest.type === "sex" ? "请选择" : "未绑定"}
          </CurText>
        ) : (
          <CurText color={theme.colors.secondary}>{rest.value}</CurText>
        )}

        {rest.icon && <CurView>{rest.icon}</CurView>}
        {isArrow && <IconFont name="right" size={14} color={theme.colors.secondaryText} />}
      </ContainerBox>
    </Container>
  )
}

export default observer(PersonalCardItem)
